export type T = {
    NoneExisting: true;
}

export function getEmpty(): T {
    return {
        NoneExisting: true
    }
}